import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMapMobile = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 33,
	height: 32,
	viewBox: "0 0 33 32",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_2452_16516",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 33,
		height: 32,
		children: /* @__PURE__ */ _jsx("rect", {
			x: .5,
			width: 32,
			height: 32,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_2452_16516)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M20.5 27.2818L12.5 24.4818L6.76166 26.7021C6.36855 26.8543 6.00443 26.8108 5.66932 26.5714C5.33421 26.3321 5.16666 26.0048 5.16666 25.5894V8.10244C5.16666 7.83911 5.23721 7.60277 5.37832 7.39344C5.51921 7.18411 5.7171 7.03244 5.97199 6.93844L12.5 4.71777L20.5 7.51777L26.2383 5.29744C26.6314 5.14522 26.9955 5.18233 27.3307 5.40877C27.6658 5.63522 27.8333 5.95189 27.8333 6.35878V23.9484C27.8333 24.2202 27.7564 24.4587 27.6027 24.6638C27.4487 24.8689 27.2401 25.0184 26.977 25.1124L20.5 27.2818ZM19.5 24.8358V9.23577L13.5 7.13811V22.7381L19.5 24.8358ZM21.5 24.8358L25.8333 23.3998V7.59977L21.5 9.23577V24.8358ZM7.16666 24.3998L11.5 22.7381V7.13811L7.16666 8.59977V24.3998Z",
			fill: "#D0DFE4"
		})
	})]
});
export default SvgMapMobile;
